const DEFAULT_SPARE_PART_CATEGORY_LABELS = [
  'Battery',
  'Hydraulic',
  'Electrical',
  'Wheel & Tire',
  'Filters',
  'Engine',
  'Transmission',
  'Cooling',
  'Fuel System',
  'Brakes',
  'Safety',
  'Lubrication',
  'Fasteners',
  'Other',
];

function normalizeCategoryKey(value = '') {
  return String(value || '')
    .normalize('NFD') // decompose accented characters into base + diacritics
    .replace(/[\u0300-\u036f]/g, '') // remove diacritic marks
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function normalizeLabelI18n(label, labelI18n = {}) {
  const base = String(label || '').trim();
  const en = String(labelI18n?.en || '').trim();
  const fr = String(labelI18n?.fr || '').trim();
  return {
    en: en || base,
    fr: fr || base,
  };
}

function buildDefaultSparePartCategories() {
  return DEFAULT_SPARE_PART_CATEGORY_LABELS.map((label) => ({
    key: normalizeCategoryKey(label),
    label,
    labelI18n: normalizeLabelI18n(label),
    locked: true,
  }));
}

function validateSparePartCategoryPayload(payload = {}) {
  const label = String(payload.label || '').trim();
  if (!label) {
    return { ok: false, error: 'Category label is required' };
  }
  const labelEn = String(payload?.labelI18n?.en || '').trim();
  if (!labelEn) {
    return { ok: false, error: 'English category label is required' };
  }
  const labelFr = String(payload?.labelI18n?.fr || '').trim();
  if (!labelFr) {
    return { ok: false, error: 'French category label is required' };
  }

  return {
    ok: true,
    value: {
      key: normalizeCategoryKey(payload.key || label),
      label,
      labelI18n: { en: labelEn, fr: labelFr },
      locked: Boolean(payload.locked),
    },
  };
}

module.exports = {
  DEFAULT_SPARE_PART_CATEGORY_LABELS,
  buildDefaultSparePartCategories,
  normalizeCategoryKey,
  normalizeLabelI18n,
  validateSparePartCategoryPayload,
};
